import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { CreateQuoteApiParameter, GetQuoteApiParameter } from "@insite/client-framework/Services/QuoteService";
import { QuoteModel } from "@insite/client-framework/Types/ApiModels";

const baseUrl = "/api/v1/customwishlist/putupstatus";

export interface GenericModalApiParameter extends ApiParameter {
    wishListId: string;
    wishListLineIds: string[];
}

export async function setWishListsSpoolStatus(body?: GenericModalApiParameter): Promise<ServiceResult<any>> {
    try {
        const result = await post<any>(`${baseUrl}`, body);

        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
